module.exports = __webpack_public_path__ + "img/realestate_logo.7be47d4a.png";